module.exports = __webpack_public_path__ + "img/p2.81db8d31.png";